module.exports = __webpack_public_path__ + "img/蒙版组 152.dc93398b.png";